import {Component, DestroyRef, ElementRef, Input, afterEveryRender, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ScreenLoadService} from './screen-load.service';

/** A page's explicit readiness boundary; contains no UI and is never added to dialogs. */
@Component({selector: 'sm-screen-load', standalone: true, template: '', host: {'hidden': ''}})
export class ScreenLoadComponent {
  @Input() loading = false;
  @Input() failed = false;
  private readonly route = inject(ActivatedRoute, {optional: true});
  private readonly metrics = inject(ScreenLoadService, {optional: true});
  private readonly element = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly destroyRef = inject(DestroyRef);
  private page?: HTMLElement;
  private readonly entered = () => this.signal();

  constructor() {
    afterEveryRender(() => {
      this.bindPage();
      this.signal();
    });
    this.destroyRef.onDestroy(() => this.page?.removeEventListener('ionViewDidEnter', this.entered));
  }

  private bindPage(): void {
    if (this.page) return;
    const page = this.element.nativeElement.closest<HTMLElement>('.ion-page');
    if (!page) return;
    this.page = page;
    page.addEventListener('ionViewDidEnter', this.entered);
  }

  private signal(): void {
    if (this.route) this.metrics?.rendered(this.route, this.loading, this.failed, () => this.visible());
  }

  private visible(): boolean {
    return !this.page || (!this.page.classList.contains('ion-page-hidden')
      && !this.page.classList.contains('ion-page-invisible') && this.page.getAttribute('aria-hidden') !== 'true');
  }
}
